/* eslint-disable */
export function activateDarkMode() {
  const body = document.getElementsByTagName("body")[0];
  body.classList.add("bg-gray-600", "dark-version");
}

export function deactivateDarkMode() {
  const body = document.getElementsByTagName("body")[0];
  body.classList.remove("bg-gray-600", "dark-version");
  body.classList.add("bg-gray-100");
}
